import { ReactNode } from "react";

import { Title } from "../Title/Title";
import "./SmallTitle.scss";

interface Props {
  className?: string;
  text: string | ReactNode;
  primary?: boolean;
}

export const SmallTitle = ({ className = "", primary, text }: Props) => {
  return (
    <Title
      className={`small-title ${className} ${
        primary ? "small-title__primary" : ""
      }`}
      text={text}
    />
  );
};
